/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Choice/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Choice({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/Permissions/VisibilitySelect/Choice"
  
}) {
let optionIdValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'id',
})
let optionTextValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'text',
})
let optionIsSelectedValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isSelected',
})
let optionIsDisabledValueData = fromData.useDataValue({ viewPath,
context: 'option',
path: 'isDisabled',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="option.id"
 id={optionIdValueData}
 onClick={onClick}
 data="option.text"
 text={optionTextValueData}
 data="option.isSelected"
 isSelected={optionIsSelectedValueData}
 data="option.isDisabled"
 isDisabled={optionIsDisabledValueData}
/>
{children}
</React.Fragment>)
}